import $vuetify from 'vuetify/es5/locale/de';

const i18n = {
  'app.name': 'appologic',
  'exit-alert': 'Drücke erneut zum beenden',
  $vuetify,
  login: {
    login: 'Login',
    username_or_email: 'E-Mail-Adresse/Benutzername',
    password: 'Passwort',
    send: 'Einloggen',
    remember: 'Eingeloggt bleiben',
    url: 'Url',
    for_company: 'Login für: {company}'
  },
  'login-description': 'Loggen Sie sich mit Ihrem Account ein',
  misc: {
    start: 'Start',
    cancel: 'Abbrechen',
    ok: 'Ok',
    save: 'Speichern',
    next: 'Weiter',
    previous: 'Zurück',
    choose: 'Auswählen',
    send: 'Senden',
    yes: 'Ja',
    no: 'Nein',
    update_available: 'Update verfügbar',
    reload: 'Aktualisieren',
    add: 'Hinzufügen'
  },
  home: {
    new: 'Neu',
    started: 'Gestartet',
    saved: 'Vorlagen',
    sent: 'Gesendet',
    logout: 'Ausloggen?',
    logout_warning: '',
    select_group: 'Gruppe wählen',
    all_groups: 'Alle Gruppen'
  },
  notifications: {
    title: 'Benachrichtigungen',
    download_attachment: 'Anhang herunterladen',
    personal: 'Persönlich - {count}',
    groups: 'Gruppen - {count}',
    messages: {
      'Message answered': 'Nachricht beantwortet'
    }
  },
  form: {
    index: {
      titles: {
        new: 'Neue Formulare',
        started: 'Gestartete Formulare',
        saved: 'Vorlagen',
        sent: 'Gesendete Formulare',
        sync: 'In Übermittlung'
      },
      'received-at': 'Erhalten am: {date}',
      'started-at': 'Gestartet am: {date}',
      'sent-at': 'Gesendet am: {date}',
      'not-started': 'Nicht gestartet',
      'start-form': 'Formular starten',
      'start-warning': `
        Dieses Formular wird in gestartete Formulare übertragen.<br>
        Die Startzeit wird gespeichert. Sind Sie sicher?<br><br>
        Startzeit: {time}
      `,
      'transfer-remaining': 'Senden ausstehend',
      actions: 'Aktionen',
      share: 'Teilen',
      delete_warning: 'Sind Sie sicher, dass Sie das Formular löschen möchten?',
      delete: 'Löschen',
      share_email: 'Geben Sie eine E-Mail Adresse an'
    },
    show: {
      'job-instruction': 'Arbeitsanweisung',
      'head-form': 'Kopfformular',
      'main-form': 'Formular',
      fill: 'Ausfüllen',
      'testing-table': 'Prüftabelle',
      'main-menu': 'Hauptmenü'
    },
    chat: {
      file: 'Datei',
      attachment: 'Anhang: ',
      send: 'Senden'
    },
    uploads_remaining: '%s verbleibende Datei Uploads',
    goback: {
      title: 'Formular verlassen',
      message: 'Wollen Sie das Formular wirklich verlassen?\nUngespeicherte Änderungen werden verworfen.'
    },
    data: {
      uploads_not_completed: 'Upload nicht abgeschlossen',
      uploads_not_completed_desc: 'Es sind noch Uploads aktiv. Wenn Sie speichern werden diese verworfen.\nTrotzdem speichern?'
    },
    send: {
      warning: 'Sind Sie sicher, dass Sie das Formular senden möchten?',
      'num-value': 'Wert: %s'
    },
    elements: {
      audio: {
        name: 'Audio',
        choose: 'Aufnahme auswählen'
      },
      barcode: {
        name: 'Barcode',
        code_defect: 'Barcode beschädigt',
        camera: 'Kamera',
        choose: 'Barcode scannen'
      },
      checkbox: {
        name: 'Einzel-Auswahl',
        answer_pairs: {
          default: { true: 'Ja', false: 'Nein' },
          true_false: { true: 'Wahr', false: 'Falsch' },
          accept_decline: { true: 'Zustimmen', false: 'Ablehnen' }
        }
      },
      date: {
        name: 'Datum',
        choose: 'Datum auswählen',
        choose_time: 'Zeit auswählen'
      },
      file: {
        filename: 'Dateiname',
        name: 'Datei',
        choose: 'Datei auswählen'
      },
      image: {
        name: 'Bild',
        choose: 'Bild auswählen',
        camera: 'Kamera',
        gallery: 'Galerie',
        mode: 'Modus'
      },
      input: {
        name: 'Eingabefeld'
      },
      location: {
        name: 'Standort',
        choose: 'Standort auswählen'
      },
      scale: {
        name: 'Skala',
        current: 'Aktuell: %s'
      },
      scribble: {
        name: 'Zeichnung',
        choose: 'Zeichnung machen'
      },
      select: {
        name: 'Auswahl',
        choose: 'Bitte wählen',
        custom: 'Eigener Wert'
      },
      signature: {
        name: 'Unterschrift',
        choose: 'Unterschrift setzen'
      },
      text: {}
    }
  },
  errors: {
    alert_title: 'Fehler',
    alert_text: 'Bei Ihrer Anfrage ist ein Fehler aufgetreten',
    token_expired_alert_title: 'Sitzung abgelaufen',
    token_expired_alert_text: 'Bitte loggen Sie sich erneut ein'
  }
};

export default { de: i18n };
